import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import exact from 'prop-types-exact';
import { closeLeaseAddModal } from '../actions';
import { getLeaseAddModal } from '../selectors';
import FormWrapper from '../containers/FormWrapper';


const propTypes = exact({
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
});


const LeaseAddModal = (props) => {
  const { show, onHide } = props;

  return (
    <Modal
      show={show}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>Add Lease</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormWrapper
          onHide={onHide}
        />
      </Modal.Body>
    </Modal>
  );
};


LeaseAddModal.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    show: getLeaseAddModal(state),
  };
};

const mapDispatchToProps = {
  onHide: closeLeaseAddModal,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(LeaseAddModal);
